import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { expressInterest, getOpportunity, listFeed, myInterests } from "./api";

export const useFeed = () => useQuery({ queryKey: ["opportunities"], queryFn: listFeed });

export const useOpportunity = (id: string | undefined) =>
  useQuery({
    queryKey: ["opportunities", id],
    queryFn: () => getOpportunity(id as string),
    enabled: !!id,
  });

export const useMyInterests = () => useQuery({ queryKey: ["interests"], queryFn: myInterests });

export function useExpressInterest(opportunityId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { amountIntended?: string; message?: string }) =>
      expressInterest(opportunityId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["interests"] }),
  });
}
